import { Service } from 'react-service-locator';
import axiosInstance from '../axios/axiosAuthInterceptor';

export type MasterUserDto = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    licenseType: number | string;
    licenseEnd?: string | null;
};

export type SubscriptionInfoResponse = {
    subscriptionId: string | null;
    status: string;
    cancelAtPeriodEnd: boolean;
    periodStartUtc: string | null;
    periodEndUtc: string | null;
    collectionMethod: string | null;
    currency: string;

    licenseType: string;
    hasStripeSubscription: boolean;
    canChooseLicense: boolean;
};

export type DemoUserEditDto = {
    id: string;
    generalEmail: string;
    generalPhone: string;
    company: string;
    address: string;
    userEmail: string;
    userPhone: string;
    firstName: string;
    lastName: string;
    title?: number;
    licenseType: number | string;
    licenseEnd?: string | null;
};

export type UpdateDemoUserDto = {
    id: string;
    generalEmail: string;
    generalPhone: string;
    company: string;
    address: string;
    userEmail: string;
    userPhone: string;
    firstName: string;
    lastName: string;
    title?: number;
    licenseEnd?: string | null;
};

type SubscriptionDto = {
    id: string;
    planName: string; // e.g. "Basislicentie"
    description?: string; // e.g. "Een individueel account..."
    currency: string; // e.g. "eur"
    amountCents: number; // e.g. 25000
    interval: 'month' | 'year';
    currentPeriodEnd: string; // ISO string
    cancelAtPeriodEnd: boolean; // true if renewal already cancelled
    status: string; // active, canceled, etc.
};

@Service()
export class UserService {
    async fetchAllUsers(): Promise<MasterUserDto[]> {
        const response = await axiosInstance.get('/User/all');
        return response.data;
    }

    async fetchUserById(id: string): Promise<DemoUserEditDto> {
        const response = await axiosInstance.get(`/User/${id}`);
        return response.data;
    }

    async updateDemoUser(payload: UpdateDemoUserDto) {
        const response = await axiosInstance.put('/User/demo', payload);
        return response.data;
    }

    async getSubscription(): Promise<SubscriptionInfoResponse> {
        const res = await axiosInstance.get('/stripe/subscription');
        return res.data;
    }

    async cancelSubscription(): Promise<SubscriptionInfoResponse> {
        const res = await axiosInstance.post('/stripe/subscription/cancel');
        return res.data;
    }

    async resumeSubscription(): Promise<SubscriptionInfoResponse> {
        const res = await axiosInstance.post('/stripe/subscription/resume');
        return res.data;
    }
}
